function escapeData(data: any): any {
    if (data === undefined || data === null) {
        return ''; 
    } else if (typeof data === 'string') {
        return data.replace(/[&<>'"]/g,
            tag => ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                "'": '&#39;',
                '`' : ' '
            }[tag] || tag));
    } else if (Array.isArray(data)) {
        return data.map(item => escapeData(item));
    } else if (typeof data === 'object') {
        const escapedObject: { [key: string]: any } = {};
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                escapedObject[key] = escapeData(data[key]);
            }
        }
        return escapedObject;
    } else {
        return data;
    }
}

export default escapeData;
